import React from 'react';
import {connect} from 'react-redux';

import {
  selectArrivals,
  selectDepartures,
  selectRoomMoves,
  selectPendingRenewals,
  selectArrivalsLoading,
  selectDeparturesLoading,
  selectRoomMovesLoading,
  selectPendingRenewalsLoading
} from 'ducks/frontDesk';

import arrivalsIcon from './assets/arrivals.svg';
import departuresIcon from './assets/departures.svg';
import roomChangesIcon from './assets/room-changes.svg';
import renewalsIcon from './assets/renewals.svg';

import './styles.css';

const InfoSection = ({
  arrivals,
  arrivalsLoading,
  departures,
  departuresLoading,
  roomMoves,
  roomMovesLoading,
  renewals,
  renewalsLoading
}) => {
  const arrivalsCount = arrivals.length;
  const departuresCount = departures.length;
  const roomMovesCount = roomMoves.length;
  const renewalsCount = renewals.length;

  const boxes = [
    {
      image: arrivalsIcon,
      amount: arrivalsCount,
      label: 'Arrivals',
      loading: arrivalsLoading
    },
    {
      image: departuresIcon,
      amount: departuresCount,
      label: 'Departures',
      loading: departuresLoading
    },
    {
      image: roomChangesIcon,
      amount: roomMovesCount,
      label: 'Room Changes',
      loading: roomMovesLoading
    },
    {
      image: renewalsIcon,
      amount: renewalsCount,
      label: 'Stayovers',
      loading: renewalsLoading
    }
  ];

  return (
    <div className="InfoSection">
      {boxes.map((box, index) => (
        <div key={index} className="column">
          <div className="image">
            <img src={box.image} alt={box.label} />
          </div>
          <div className="info">
            <div className="amount">
              {box.loading && '...'}
              {!box.loading && box.amount}
            </div>
            <div className="label">{box.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    arrivals: selectArrivals(state),
    arrivalsLoading: selectArrivalsLoading(state),
    departures: selectDepartures(state),
    departuresLoading: selectDeparturesLoading(state),
    roomMoves: selectRoomMoves(state),
    roomMovesLoading: selectRoomMovesLoading(state),
    renewals: selectPendingRenewals(state),
    renewalsLoading: selectPendingRenewalsLoading(state)
  };
};

export default connect(mapStateToProps, null)(InfoSection);
